import { render } from "./WaiterModal.vue?vue&type=template&id=061b968c&scoped=true"
import script from "./WaiterModal.vue?vue&type=script&lang=js"
export * from "./WaiterModal.vue?vue&type=script&lang=js"

import "./WaiterModal.vue?vue&type=style&index=0&id=061b968c&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061b968c"]])

export default __exports__